(() => {
  let drawer = document.getElementById('ClCartDrawer');
  if (!drawer || typeof drawer.showModal !== 'function' || !window.fetch) return;
  let content = drawer.querySelector('[data-cart-drawer-content]');
  let errorBox = drawer.querySelector('[data-cart-error]');
  const status = document.getElementById('ClCartStatus');
  let sectionId = drawer.dataset.sectionId;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let opener = null;
  const disabledStates = new Map();
  const announce = (message) => { if (status) status.textContent = message; };
  const syncScrollLock = () => document.body.classList.toggle('cl-overlay-open', drawer.open || !!document.querySelector('.cl-header[data-menu-open="true"]'));
  const setError = (message = '') => {
    errorBox.textContent = message;
    errorBox.hidden = !message;
  };
  const setBusy = (value) => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    if (value) {
      document.querySelectorAll('.cl-quick-add [name="add"], .cl-product-form [name="add"], #ClCartDrawer [data-cart-adjust], #ClCartDrawer [data-cart-quantity], #ClCartDrawer [data-cart-remove], #ClCartDrawer [name="checkout"], #ClCartDrawer [data-cart-retry]').forEach(control => {
        disabledStates.set(control, control.disabled);
        control.disabled = true;
      });
      announce(drawer.dataset.loadingLabel);
    } else {
      disabledStates.forEach((disabled, control) => { if (control.isConnected) control.disabled = disabled; });
      disabledStates.clear();
    }
  };
  const updateCount = (count) => {
    if (!Number.isFinite(count)) return;
    drawer.dataset.itemCount = String(count);
    document.querySelectorAll('.cl-cart-count').forEach(badge => { badge.textContent = count; });
    drawer.querySelector('[data-cart-count]').textContent = `(${count})`;
    document.querySelectorAll('[data-cart-open]').forEach(link => {
      link.setAttribute('aria-label', `${link.dataset.cartLabel}, ${count} ${link.dataset.itemsLabel}`);
    });
  };
  const open = (trigger) => {
    if (drawer.open) return;
    opener = trigger || document.activeElement;
    document.dispatchEvent(new CustomEvent('cl:close-menu'));
    drawer.showModal();
    syncScrollLock();
    drawer.querySelector('[data-cart-close]').focus({preventScroll: true});
  };
  const close = () => { if (drawer.open) drawer.close(); };
  const bindDialog = () => {
    drawer.addEventListener('close', () => {
      syncScrollLock();
      if (opener?.isConnected) opener.focus({preventScroll: true});
    });
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        const rect = drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    });
  };
  bindDialog();
  document.addEventListener('shopify:section:load', (event) => {
    const replacement = event.target.querySelector('#ClCartDrawer');
    if (!replacement || replacement === drawer) return;
    const wasOpen = drawer.open;
    if (wasOpen) drawer.close();
    drawer = replacement;
    content = drawer.querySelector('[data-cart-drawer-content]');
    errorBox = drawer.querySelector('[data-cart-error]');
    sectionId = drawer.dataset.sectionId;
    bindDialog();
    if (wasOpen) open();
  });
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.contains(drawer)) open();
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.contains(drawer)) close();
  });

  const sectionURL = () => {
    const url = new URL(drawer.dataset.cartUrl, window.location.origin);
    const current = new URL(window.location.href);
    ['preview_theme_id', '_fd', 'pb'].forEach(key => {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    url.searchParams.set('section_id', sectionId);
    return url;
  };
  const render = (html) => {
    if (!html) return false;
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('#ClCartDrawer');
    const nextContent = next?.querySelector('[data-cart-drawer-content]');
    if (!nextContent) return false;
    const scroll = content.querySelector('.cl-cart-drawer__items')?.scrollTop || 0;
    const focusId = document.activeElement?.dataset.cartFocus;
    content.replaceChildren(...nextContent.childNodes);
    updateCount(Number(next.dataset.itemCount));
    const list = content.querySelector('.cl-cart-drawer__items');
    if (list) list.scrollTop = scroll;
    if (focusId && drawer.open) {
      const target = [...content.querySelectorAll('[data-cart-focus]')].find(control => control.dataset.cartFocus === focusId);
      (target || drawer.querySelector('[data-cart-close]')).focus({preventScroll: true});
    }
    return true;
  };
  const refresh = async (sections) => {
    if (render(sections?.[sectionId])) return;
    const response = await fetch(sectionURL(), {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok || !render(await response.text())) throw new Error(drawer.dataset.refreshErrorLabel);
  };
  const showRefreshError = () => {
    const template = drawer.querySelector('[data-cart-refresh-error]');
    content.replaceChildren(template.content.cloneNode(true));
    announce(drawer.dataset.refreshErrorLabel);
  };
  const request = async (path, data) => {
    const isForm = data instanceof FormData;
    const context = window.location.pathname + window.location.search;
    if (isForm) {
      data.set('sections', sectionId);
      data.set('sections_url', context);
    } else {
      data.sections = [sectionId];
      data.sections_url = context;
    }
    const response = await fetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: isForm ? {Accept: 'application/json'} : {Accept: 'application/json', 'Content-Type': 'application/json'},
      body: isForm ? data : JSON.stringify(data)
    });
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : drawer.dataset.errorLabel);
    return result;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.cl-quick-add, .cl-product-form')) return;
    // Accelerated checkout keeps its explicit purchase action.
    if (event.submitter && event.submitter.name !== 'add') return;
    event.preventDefault();
    if (busy) return;
    const data = new FormData(form);
    const button = event.submitter || form.querySelector('[name="add"]');
    form.querySelector('.cl-product-form__error')?.remove();
    setError();
    setBusy(true);
    let added = false;
    try {
      const result = await request('cart/add.js', data);
      added = true;
      await refresh(result.sections);
      open(button);
      announce(drawer.dataset.addedLabel);
      document.dispatchEvent(new CustomEvent('cl:cart-updated'));
    } catch (error) {
      if (added) {
        showRefreshError();
        open(button);
      } else {
        const message = error.message || drawer.dataset.errorLabel;
        const notice = document.createElement('p');
        notice.className = 'cl-product-form__error';
        notice.setAttribute('role', 'alert');
        notice.textContent = message;
        form.append(notice);
        announce(message);
      }
    } finally { setBusy(false); }
  });

  const changeQuantity = async (line, quantity) => {
    if (busy || !line || !Number.isSafeInteger(quantity) || quantity < 0) return;
    setError();
    setBusy(true);
    let changed = false;
    try {
      const result = await request('cart/change.js', {id: line.dataset.cartKey, quantity});
      changed = true;
      updateCount(result.item_count);
      await refresh(result.sections);
      announce(drawer.dataset.updatedLabel);
      document.dispatchEvent(new CustomEvent('cl:cart-updated'));
    } catch (error) {
      if (changed) showRefreshError();
      else {
        setError(error.message || drawer.dataset.errorLabel);
        // The server remains authoritative if stock or quantity rules reject the edit.
        try { await refresh(); } catch (_) { /* Keep the error and existing cart visible. */ }
      }
    } finally { setBusy(false); }
  };
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-cart-open]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    open(trigger);
    if (busy) return;
    setError();
    setBusy(true);
    try { await refresh(); } catch (_) { showRefreshError(); }
    finally { setBusy(false); }
  });
  document.addEventListener('click', async (event) => {
    if (!drawer.contains(event.target)) return;
    if (event.target.closest('[data-cart-close]')) { close(); return; }
    if (event.target.closest('[data-cart-retry]')) {
      if (busy) return;
      setBusy(true);
      try { await refresh(); } catch (_) { showRefreshError(); }
      finally { setBusy(false); }
      return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    const adjust = event.target.closest('[data-cart-adjust]');
    if (!remove && !adjust) return;
    const line = (remove || adjust).closest('[data-cart-key]');
    const input = line.querySelector('[data-cart-quantity]');
    const quantity = remove ? 0 : Math.max(0, Number(input.value) + Number(adjust.dataset.cartAdjust));
    await changeQuantity(line, quantity);
  });
  document.addEventListener('change', (event) => {
    if (!drawer.contains(event.target)) return;
    if (!event.target.matches('[data-cart-quantity]')) return;
    const input = event.target;
    if (!input.checkValidity()) { input.reportValidity(); return; }
    changeQuantity(input.closest('[data-cart-key]'), Number(input.value));
  });
  // A pending quantity change must finish before the shopper explicitly checks out.
  document.addEventListener('submit', event => { if (drawer.contains(event.target) && busy) event.preventDefault(); });
})();
